import { useEffect, useState } from "react";
import Loading from "../loading/Loading";
import { Link } from "react-router-dom";
import { Alert, Button, Col, Form, Row, Table } from "react-bootstrap";
import { Typeahead } from "react-bootstrap-typeahead";
import { getOrderReceiptUrl, getOrders, setOrdersToken, updateOrderDeliveryStatus } from "../../controllers/orders";
import { getOrg } from "../../controllers/org";
import OrderDetailsModal from "../orders/OrderDetailsModal";
import { useAuth } from "../auth/AuthProvider";

function OrdersNacional({}) {
  const { token } = useAuth();
  const [orders, setOrders] = useState();
  const [showPayModal, setShowPayModal] = useState(false);
  const [modalOrder, setModalOrder] = useState();
  const [loading, setLoading] = useState(true);
  const [comunidades, setComunidades] = useState([]);

  // Filter state
  const [filterEmail, setFilterEmail] = useState('');
  const [filterFechaDesde, setFilterFechaDesde] = useState('');
  const [filterFechaHasta, setFilterFechaHasta] = useState('');
  const [filterOrderStatus, setFilterOrderStatus] = useState('');
  const [filterDeliveryStatus, setFilterDeliveryStatus] = useState('');
  const [filterComunidad, setFilterComunidad] = useState([]);

  setOrdersToken(token);

  useEffect(() => {
    loadHistory();
    getOrg().then(o => setComunidades(o.comunidades || []));
  }, []);

  async function loadHistory(filters = {}) {
    setLoading(true);
    console.log('getting orders');
    let o = await getOrders({
      orderType: 'material',
      ...filters,
    });
    setOrders(o);
    setLoading(false);
  }

  function buildFilters() {
    const filters = {};
    if (filterEmail) filters.email = filterEmail;
    if (filterOrderStatus) filters.orderStatus = filterOrderStatus;
    if (filterDeliveryStatus) filters.deliveryStatus = filterDeliveryStatus;
    if (filterComunidad.length) filters.comunidad = filterComunidad[0].comunidad_id;
    if (filterFechaDesde) filters.startTime = new Date(filterFechaDesde).getTime();
    if (filterFechaHasta) {
      // include the full end day
      const end = new Date(filterFechaHasta);
      end.setHours(23, 59, 59, 999);
      filters.endTime = end.getTime();
    }
    return filters;
  }

  function handleSearch(e) {
    e.preventDefault();
    loadHistory(buildFilters());
  }

  function handleClear() {
    setFilterEmail('');
    setFilterFechaDesde('');
    setFilterFechaHasta('');
    setFilterOrderStatus('');
    setFilterDeliveryStatus('');
    setFilterComunidad([]);
    loadHistory();
  }

  if (!orders && loading) {
    return <Loading />
  }

  function showModal(e) {
    e.preventDefault();
    let o = orders.find(or => or.order_id === parseInt(e.target.dataset.order_id));
    setModalOrder(o);
  }
  function hideModal() {
    setModalOrder(false);
  }

  async function downloadReceipt(orderId) {
    const win = window.open('', '_blank');
    if (!win) {
      window.alert('No se pudo abrir la ventana para mostrar el recibo. Verifica el bloqueador de popups.');
      return;
    }
    win.document.write('<!doctype html><html><head><meta charset="utf-8"/><title>Generando recibo...</title></head><body style="font-family: sans-serif; padding: 24px;">Generando recibo...</body></html>');
    win.document.close();

    try {
      const receipt = await getOrderReceiptUrl(orderId);

      if (receipt?.source === 'stripe' && receipt?.receiptUrl) {
        win.location.href = receipt.receiptUrl;
        return;
      }

      if (receipt?.source === 'internal' && receipt?.html) {
        win.document.open();
        win.document.write(receipt.html);
        win.document.close();
        return;
      }

      if (typeof receipt === 'string' && receipt) {
        win.location.href = receipt;
        return;
      }

      win.close();
      window.alert('No fue posible obtener el recibo de la orden.');
    }
    catch (e) {
      win.close();
      window.alert(e?.message || 'No fue posible obtener el recibo de la orden.');
    }
  }

  function StatusUpdateForm({ orderId }) {
    const [status, setStatus] = useState('');
    async function onSubmit(e) {
      e.preventDefault();
      console.log(`Updating status of order: ${orderId}. Status: ${status}`);
      if (!status) {
        return;
      }
      try {
        await updateOrderDeliveryStatus(orderId, status);
        console.log('Successfully updated order.');
        loadHistory(buildFilters());
      }
      catch(e) {
        console.log(e);
      }
    }
    return <Form onSubmit={onSubmit}>
      <Form.Group className="mb-3">
        <Form.Label>Actualizar a:</Form.Label>
        <Form.Select onChange={e => setStatus(e.target.value)}>
          <option value=''>Selecciona un estado</option>
          <option value='en proceso'>En Proceso</option>
          <option value='enviado'>Enviado</option>
          <option value='entregado'>Entregado</option>
          <option value='cancelada'>Cancelada</option>
        </Form.Select>
      </Form.Group>
      <Button type="submit">Guardar</Button>
    </Form>
  }
  
  function renderOrders() {
    return orders.map((o, i) => {
      let fecha = new Date(o.createdAt);
      let total = 0;
      o.line_items.forEach(li => {
        total += parseInt(li.product_original_price) * li.quantity;
      });
      return <tr key={`order-${o.order_id}`}>
        <td>{o.order_id}</td>
        <td>{fecha.toLocaleDateString()} {fecha.toLocaleTimeString()}</td>
        <td>
          {o.membership.user.email}<br/><br/>
          {o.formatUserData.nombres}<br/>
          {o.formatUserData.direccion}
        </td>
        <td className={o.order_status === 'Pagada' ? 'text-success': 'text-danger'}>
          {o.order_status}
        </td>
        <td>
          <b style={{textTransform: 'capitalize'}}>{o.delivery_status}</b><br/><br/>
          <StatusUpdateForm orderId={o.order_id} />
        </td>
        <td>${total}</td>
        <td>Comunidad: <b>{o.membership.comunidad?.label}</b><br/>{o.membership.region?.label} / {o.membership.diocesis?.label}</td>
        <td>
          {o.order_status === 'Pagada' && <><Button variant="outline-primary" size="sm" onClick={() => downloadReceipt(o.order_id)}>Descargar recibo</Button>{' '}</>}
          <Link onClick={showModal} data-order_id={o.order_id}>Ver detalles</Link>
        </td>
      </tr>
    });
  }

  return <>
    <Form onSubmit={handleSearch} className="mb-3 p-3 border rounded bg-light">
      <Row className="g-2 align-items-end">
        <Col xs={12} md={4}>
          <Form.Label className="fw-semibold mb-1">Email / Usuario</Form.Label>
          <Form.Control
            type="text"
            placeholder="Buscar por email"
            value={filterEmail}
            onChange={e => setFilterEmail(e.target.value)}
          />
        </Col>
        <Col xs={12} md={4}>
          <Form.Label className="fw-semibold mb-1">Comunidad</Form.Label>
          <Typeahead
            id="filter-comunidad"
            labelKey="label"
            options={comunidades}
            placeholder="Buscar por comunidad"
            selected={filterComunidad}
            onChange={setFilterComunidad}
            clearButton
          />
        </Col>
        <Col xs={6} md={2}>
          <Form.Label className="fw-semibold mb-1">Estatus de pago</Form.Label>
          <Form.Select value={filterOrderStatus} onChange={e => setFilterOrderStatus(e.target.value)}>
            <option value=''>Todos</option>
            <option value='Pagada'>Pagada</option>
            <option value='Pago pendiente'>Pago pendiente</option>
            <option value='En proceso'>En proceso</option>
            <option value='Cancelada'>Cancelada</option>
          </Form.Select>
        </Col>
        <Col xs={6} md={2}>
          <Form.Label className="fw-semibold mb-1">Estatus de envío</Form.Label>
          <Form.Select value={filterDeliveryStatus} onChange={e => setFilterDeliveryStatus(e.target.value)}>
            <option value=''>Todos</option>
            <option value='en proceso'>En Proceso</option>
            <option value='enviado'>Enviado</option>
            <option value='entregado'>Entregado</option>
            <option value='cancelada'>Cancelada</option>
          </Form.Select>
        </Col>
        <Col xs={6} md={2}>
          <Form.Label className="fw-semibold mb-1">Fecha desde</Form.Label>
          <Form.Control
            type="date"
            value={filterFechaDesde}
            onChange={e => setFilterFechaDesde(e.target.value)}
          />
        </Col>
        <Col xs={6} md={2}>
          <Form.Label className="fw-semibold mb-1">Fecha hasta</Form.Label>
          <Form.Control
            type="date"
            value={filterFechaHasta}
            onChange={e => setFilterFechaHasta(e.target.value)}
          />
        </Col>
        <Col xs={12} md="auto" className="d-flex gap-2 mt-1">
          <Button type="submit" variant="primary">Buscar</Button>
          <Button type="button" variant="outline-secondary" onClick={handleClear}>Limpiar</Button>
        </Col>
      </Row>
    </Form>

    {loading && <Loading />}

    {!loading && orders && !orders.length && (
      <Alert variant="warning">No se encontraron órdenes con los filtros seleccionados.</Alert>
    )}

    {!loading && orders && orders.length > 0 && (
      <Table striped hover>
        <thead>
          <tr>
            <td>Número de orden</td>
            <td>Fecha</td>
            <td>Usuario</td>
            <td>Pagado</td>
            <td>Estatus</td>
            <td>Monto</td>
            <td>Comunidad</td>
            <td>Detalles</td>
          </tr>
        </thead>
        <tbody>
          {renderOrders()}
        </tbody>
      </Table>
    )}

    <OrderDetailsModal
      show={!!modalOrder} 
      handleClose={hideModal} 
      handleDownloadReceipt={modalOrder?.order_status === 'Pagada' ? () => downloadReceipt(modalOrder.order_id) : null}
      order={modalOrder}
    />
  </>;
}

export default OrdersNacional;